/**
 * Application version (SemVer) — single source of truth for the runtime version shown in the
 * API /health response and the UI footer. Bump this together with the package.json `version`
 * fields on every release, and tag the release commit `v<this>` (see CHANGELOG.md).
 */
export const APP_VERSION = '1.18.0';
//# sourceMappingURL=version.js.map